module.exports = __webpack_public_path__ + "static/5.0da43474.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/slider/5.png
// module id = 449
// module chunks = 35783957827783